import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import LeadContext from '../../providers/Lead/Lead.context';
import useLeadStagesCopy from 'hooks/useLeadStagesCopy';
import DealSoftSignals from './components/DealSoftSignals';
import PulseIcon from 'icons/Pulse.icon';

import './BuyerPulseCheckCard.styles.scss';

type BuyerPulseCheckCardProps = {
  className?: string;
};

const BuyerPulseCheckCard: React.FC<BuyerPulseCheckCardProps> = (props) => {
  const { className } = props;

  const { buyerStep, onSubmitCheckPulse } = useContext(LeadContext);

  const status = useLeadStagesCopy().getCopies()?.[buyerStep];

  const classes = classNames('buyer-pulse-check-card', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p className="title">
        <PulseIcon />
        {t('pulseCheck')}
      </p>

      <p>{t('buyerPulseCheckCardDescription', { status })}</p>

      <DealSoftSignals onSubmit={onSubmitCheckPulse} />
    </div>
  );
};

export default BuyerPulseCheckCard;
